import {styled} from '@mui/material';

export const InfoContainer = styled('div')`
	border: 2px solid ${({theme}) => theme.colors.light.secondary.main};
	border-radius: 8px;
	padding: 16px;
	margin-block: 16px;
`;
